import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Tag } from 'lucide-react';
import { DetailPackage, PRICE_TIER_SM, PRICE_TIER_SUV } from '../data/packages';
import { specials } from '../data/specials';

/** Price, inclusions, requirements and any live special for one package page. */
export function PackagePricing({
  pkg
}: {
  pkg: DetailPackage;
}) {
  const special = specials.find(s => s.packageSlug === pkg.slug);
  const accentBorder = pkg.accent === 'blue' ? 'border-blue-500' : 'border-green-500';
  const accentText = pkg.accent === 'blue' ? 'text-blue-400' : 'text-green-400';
  return <div className="not-prose my-10 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-263" data-mp="10s5f7ymw753a">
      <div className={`bg-zinc-900/80 border-2 ${accentBorder} rounded-lg p-6`} data-id="element-264" data-mp="w1fcyu9rjict">
        <h2 className={`text-2xl font-black uppercase ${accentText}`} data-id="element-265" data-mp="vzca39nihuqo">
          {pkg.name} Pricing
        </h2>
        <dl className="mt-5 grid grid-cols-2 gap-4 text-center" data-id="element-266" data-mp="3chxeywxrznr">
          <div className="bg-black/40 border border-zinc-800 rounded-lg py-4" data-id="element-267" data-mp="3c84p3kibeed">
            <dt className="text-xs sm:text-sm text-gray-500 uppercase font-bold tracking-wider" data-id="element-268" data-mp="8zygglgzg7c4">
              {PRICE_TIER_SM}
            </dt>
            <dd className="mt-1 text-4xl font-black text-white" data-id="element-269" data-mp="iqkonumddvks">{pkg.priceSm}</dd>
          </div>
          <div className="bg-black/40 border border-zinc-800 rounded-lg py-4" data-id="element-270" data-mp="npnw1lptodvx">
            <dt className="text-xs sm:text-sm text-gray-500 uppercase font-bold tracking-wider" data-id="element-271" data-mp="nrqjbxzlbswy">
              {PRICE_TIER_SUV}
            </dt>
            <dd className="mt-1 text-4xl font-black text-white" data-id="element-272" data-mp="3r5unmtuyqkoc">{pkg.priceSuv}</dd>
          </div>
        </dl>
        {pkg.requirement && <p className="mt-5 text-white font-black uppercase tracking-wide" data-id="element-273" data-mp="3w4nz6gqow1lv">
            Requirement: {pkg.requirement}
          </p>}
        {special && <Link to="/specials" className="mt-5 flex items-start gap-3 p-4 bg-yellow-400 text-black rounded-lg hover:bg-yellow-300 transition-colors duration-150" data-id="element-274" data-mp="1bf8em3i2d94o">
            <Tag className="w-5 h-5 mt-0.5 shrink-0" aria-hidden="true" data-id="element-275" data-mp="1ff8w5x0gm0fy" />
            <span data-id="element-276" data-mp="3cgeqa7ec5urr">
              <span className="block font-black uppercase" data-id="element-277" data-mp="3cfwkok5sa476">
                Special: {special.amount} off {special.service}
              </span>
              <span className="block text-sm font-semibold" data-id="element-278" data-mp="3lhw23dkpnaan">
                {special.condition ?? 'Off the listed price'} — see current specials
              </span>
            </span>
          </Link>}
      </div>

      <div className="bg-zinc-900/40 border border-zinc-800 rounded-lg p-6" data-id="element-279" data-mp="2ssyxgd9f9c0d">
        <h2 className="text-2xl font-black uppercase text-white" data-id="element-280" data-mp="2orvhlqrdjfz5">
          What's Included
        </h2>
        <ul className="mt-5 space-y-3" data-id="element-281" data-mp="32ja2k34udr8u">
          {pkg.features.map(feature => <li key={feature} className="flex items-start text-gray-200 text-lg" data-id="element-282" data-mp="32lczz88bqmnl">
              <Check className="w-5 h-5 text-red-500 mr-3 mt-1 shrink-0" aria-hidden="true" data-id="element-283" data-mp="2xr0fqvz0x7as" />
              {feature}
            </li>)}
        </ul>
      </div>
    </div>;
}